const VERSION_REF = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})@([0-9a-f]{7,64})$/;

/** Whether `text` is an exact item version `<item id>@<version>`. */
export function isVersionReference(text: string): boolean {
  return VERSION_REF.test(text);
}
